export default [
  {
    path: '',
    // redirect: { name: 'Home' },  ==> IT DOES NOT WORK!
    beforeEnter: (to, from, next) => {
      return next(`${to.path}home/`);
    }
  },
  {
    path: 'home',
    name: 'Home',
    component: () => import('./views/Home.vue'),
  },
  // Données
  {
    path: 'data',
    name: 'Data',
    component: () => import('./views/Data.vue'),
  },
  // Others
  {
    path: 'access-denied/',
    name: '403Page',
    component: () => import('./views/403Page.vue'),
  },
  {
    path: 'not-found/',
    name: 'NotFound',
    component: () => import('./views/NotFound.vue'),
  },
];
